import React, { useEffect, useState, useRef } from "react";
import Table from "../../common/Table/table";
import {
  getAllReferralCommission,
  updateReferralCommission,
  resetupdateReferralCommissionMessage,
  referralCommissionPayment,
  resetReferralPaymentMessage,
} from "../../../store/slices/referralCommission.slice";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import InputText from "../../common/Input/InputText";
import Select from "react-select";
import InputOnlyNumber from "../../common/Input/InputOnlyNumber";
import { useNavigate } from "react-router-dom";
import QRCode from "qrcode";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { handelPrint } from "./PrintPaymentVoucher";
import TataReport from "../Template/tataReport/tatareport";
import CurewellReport from "../Template/CurewellReport/Curewell";
import DefaultReport from "../Template/DefaultReport/DefaultReport";

import { getaccountType } from "../../../store/slices/accountType";
import { getBankListSlice } from "../../../store/slices/bankSlice";

const ReferralCommissionPayment = () => {
  const reportRef = useRef();
  const [searchValue, setSearchValue] = useState("");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [listOfIds, setListOfIds] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [totalReferralAmount, setTotalReferralAmount] = useState(0);
  const [selectedAccountType, setSelectedAccountType] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);

  const [reportFromData, setReportFromData] = useState({
    commissionId: "",
    paymentDetailsId: "",
    paymentStatus: "UNPAID",
    fromDate: "",
    toDate: "",
  });

  const {
    referralCommission,
    updateReferralCommissionSuccessMessage,
    updateReferralCommissionErrorMessage,
    searchMessage,
    paymentErrorMessage,
    paymentSuccessMessage,
  } = useSelector((state) => state.referralCommission);
  const { accountType } = useSelector((state) => state.accountType);
  const { bank } = useSelector((state) => state.bank);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const id = sessionStorage.getItem("id");
  const referrerId = sessionStorage.getItem("referrerId");
  const referrerName = sessionStorage.getItem("referrerName");
  const { paymentStatus } = useSelector((state) => state.tablePaidStatus);
  const navigate = useNavigate();

  // Safely extract clinic info
  const clinic = clinicInfo?.length > 0 ? clinicInfo[0] : null;
  const reportName = clinic?.reportName || "default";

  // fetch referral commissions
  useEffect(() => {
    if (!clinic) return;
    dispatch(
      getAllReferralCommission({
        referrerId,
        clinicId: clinic.clinicId,
        token,
        id,
        status: paymentStatus,
      })
    );
  }, [
    dispatch,
    clinic,
    token,
    referrerId,
    id,
    showPaymentModal,
    paymentStatus,
  ]);

  // fetch dropdown data
  useEffect(() => {
    dispatch(getaccountType({ status: ["Active"], token }));
    dispatch(getBankListSlice({ status: ["Active"], token }));
  }, [dispatch, token]);

  // handle toast messages
  useEffect(() => {
    showTostifyMessageAndReset(
      updateReferralCommissionSuccessMessage,
      showToastifySuccess,
      resetupdateReferralCommissionMessage
    );
    showTostifyMessageAndReset(
      updateReferralCommissionErrorMessage,
      showToastifyError,
      resetupdateReferralCommissionMessage
    );
    showTostifyMessageAndReset(
      paymentSuccessMessage,
      showToastifySuccess,
      resetReferralPaymentMessage
    );
    showTostifyMessageAndReset(
      paymentErrorMessage,
      showToastifyError,
      resetReferralPaymentMessage
    );
  }, [
    updateReferralCommissionSuccessMessage,
    updateReferralCommissionErrorMessage,
    paymentSuccessMessage,
    paymentErrorMessage,
    dispatch,
    showTostifyMessageAndReset,
  ]);

  const tableHead = [
    { title: "App Id", key: "appointmentId" },
    { title: "App Date", key: "appDate" },
    { title: "Patient Name", key: "patientName" },
    { title: "Total Amount", key: "totalAmount" },
    { title: "Referral Amount", key: "referralAmount" },
    { title: "Status", key: "paymentStatus" },
  ];
  const handleSearch = async (e) => {
    setSearchValue(e.target.value);
    dispatch(
      getAllReferralCommission({
        searchQuery: e.target.value,
        clinicId: clinic.clinicId,
        token,
        id,
        status: paymentStatus,
      })
    );
  };
  const handleChangeFormData = (e) => {
    setReportFromData((prevData) => ({
      ...prevData,
      paymentStatus: e.target.value,
    }));
  };
  const handleFilter = async () => {
    await dispatch(
      getAllReferralCommission({
        clinicId: clinic.clinicId,
        fromDate: reportFromData.fromDate,
        toDate: reportFromData.toDate,
        token,
        status: paymentStatus,
      })
    );
  };

  const handleClear = async () => {
    setReportFromData({
      fromDate: "",
      toDate: "",
    });

    await dispatch(
      getAllReferralCommission({
        clinicId: clinic.clinicId,
        token,
        fromDate: "",
        toDate: "",
        status: paymentStatus,
      })
    );
  };

  const handleCheckAllBox = (tableBody) => {
    const updatedCheckedItems = {};
    let totalAmount = 0;
    let allSelected = true;

    tableBody.forEach((item) => {
      if (item.paymentStatus !== "PAID") {
        updatedCheckedItems[item.id] = true;
        totalAmount += parseFloat(item.referralCommission) || 0;
      } else {
        allSelected = false;
      }
    });

    if (isCheckAll) {
      setCheckedItems({});
      setTotalReferralAmount(0);
      setIsCheckAll(false);
    } else {
      setCheckedItems(updatedCheckedItems);
      setTotalReferralAmount(totalAmount);
      setIsCheckAll(true);
    }
  };
  const handleCheckboxChange = (id) => {
    const updatedCheckedItems = {
      ...checkedItems,
      [id]: !checkedItems[id],
    };
    setCheckedItems(updatedCheckedItems);

    const selectedIds = Object.keys(updatedCheckedItems).filter(
      (key) => updatedCheckedItems[key]
    );

    const selectedItems = referralCommission[0]?.servicePaymentDetails?.filter(
      (item) =>
        selectedIds.includes(item?._id) && item?.paymentStatus !== "PAID"
    );

    const total = selectedItems.reduce(
      (sum, item) => sum + (parseFloat(item.referralAmount) || 0),
      0
    );

    setTotalReferralAmount(total);
    setListOfIds(selectedIds);
  };
  const handleUpdateReferralCommissionPayment = async () => {
    await dispatch(
      updateReferralCommission({
        commissionId: referralCommission[0]?._id,
        paymentStatus: reportFromData?.paymentStatus,
        paymentDetailsId:
          listOfIds?.length > 0 ? listOfIds : reportFromData?.paymentDetailsId,
        clinicId: clinic.clinicId,
        token,
      })
    );
    setShowPaymentModal(false);
    setIsCheckAll(false);
    setCheckedItems({});
  };
  // ✅ Print Function
  const handlePrint = async (selectedItem) => {
    console.log("print start");
    const qrCodeUrl = await QRCode.toDataURL(window.location.href);

    let ReportComponent;
    switch (clinic?.reportName?.toLowerCase()) {
      case "tatareport":
        <TataReport msg={"Referral Commission Payment Voucher"} />;
        ReportComponent = TataReport;
        break;
      case "curewellreport":
        ReportComponent = CurewellReport;
        break;
      default:
        ReportComponent = DefaultReport;
    }

    const referrer = referralCommission[0]?.referrerId;

    const container = document.createElement("div");
    container.style.position = "fixed";
    container.style.top = "-9999px";
    document.body.appendChild(container);

    const { createRoot } = await import("react-dom/client");
    const root = createRoot(container);

    root.render(
      <ReportComponent
        clinic={clinic}
        qrCode={qrCodeUrl}
        qrCodeUrl={qrCodeUrl}
        // address={clinic?.hospitalInfo?.address}
        item={selectedItem} 
        selectedItem={selectedItem}
        referrer={referrer} 
      />
    );

    await new Promise((r) => setTimeout(r, 800));

    const canvas = await html2canvas(container, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${clinic?.reportName || "report"}.pdf`);

    root.unmount();
    document.body.removeChild(container);
  };
  const handleReferralPayment = () => {
    const checkedIds = Object.entries(checkedItems)
      .filter(([_, isChecked]) => isChecked)
      .map(([id]) => id);

    if (checkedIds.length === 0) {
      alert("Please select at least one payment item.");
      return;
    }

    const payload = {
      commissionId: referralCommission[0]?._id,
      paymentDetailsId: checkedIds,
      bank: selectedBank?.value,
      account: selectedAccountType?.value,
      totalPaidReferralAmount: totalReferralAmount,
      updatedBy: id,
      token,
    };

    dispatch(referralCommissionPayment(payload)).then(() => {
      dispatch(
        getAllReferralCommission({
          referrerId,
           clinicId: clinic.clinicId,
          token,
          id,
          status: paymentStatus,
        })
      );
      setTotalReferralAmount(0);
      setSelectedBank(null);
      setSelectedAccountType(null);
      setCheckedItems({});
      setIsCheckAll(false);
      setListOfIds([]);
    });
  };

  return (
    <>
      <div className="row d-flex align-items-center mb-4">
        <div className="col-md-3">
          <div className="form-group form-focus focused">
            <label className="focus-label">From</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.fromDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    fromDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group form-focus focused">
            <label className="focus-label">To</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.toDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    toDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <button
            className="btn btn-primary mt-3"
            onClick={() => handleFilter()}
          >
            Filter
          </button>
          <button className="btn btn-danger mt-3 ms-3" onClick={handleClear}>
            Clear
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-3">
          <InputText
            name="name"
            value={referrerName}
            placeholder="Name"
            label="Name"
            fieldName="Name"
          />
        </div>
        <div className="col-xl-3">
          <InputOnlyNumber
            name="totalPayment"
            className="form-control"
            placeholder="Total Payment"
            value={totalReferralAmount.toFixed(2)}
            label="Total Payment"
            fieldName="Total Payment"
          />
        </div>
        <div className="col-xl-3">
          <div className="form-group position-relative">
            <label htmlFor="tests" className="col-form-label">
              Account Type:
            </label>
            <Select
              placeholder="Select Mode"
              options={accountType?.map((account) => ({
                value: account?._id,
                label: account?.name,
                accountObj: account,
              }))}
              value={selectedAccountType}
              onChange={(selected) => setSelectedAccountType(selected)}
            />
          </div>
        </div>
        <div className="col-xl-3">
          <div className="form-group position-relative">
            <label htmlFor="tests" className="col-form-label">
              Bank:
            </label>
            <Select
              placeholder="Select Account"
              options={bank?.map((bank) => ({
                value: bank?._id,
                label: bank?.name,
                bankObj: bank,
              }))}
              value={selectedBank}
              onChange={(selected) => setSelectedBank(selected)}
            />
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Button
          className="btn btn-primary btn-sm"
          onClick={() => navigate("/referralCommission")}
        >
          ← Back to Referral Commission
        </Button>

        <Button
          className="btn btn-primary btn-sm"
          onClick={handleReferralPayment}
          disabled={
            totalReferralAmount <= 0 || !selectedBank || !selectedAccountType
          }
        >
          Pay
        </Button>
      </div>
      <Table
        tableHead={tableHead}
        tableBody={referralCommission[0]?.servicePaymentDetails?.map(
          (item) => ({
            id: item?._id,
            appointmentId: item?.appointmentId,
            appDate: new Date(item?.appDate)?.toISOString()?.split("T")[0],
            patientName: item?.patientId?.userId?.name,
            totalAmount: item?.totalAmount,
            referralAmount: item?.referralAmount,
            paymentStatus: item?.paymentStatus,
            // age: item?.patientId?.userId?.age,
            patientId: item?.patientId?.UHID,
            gender: item?.patientId?.userId?.gender,
            age: item?.patientId?.userId?.age?.year,
            createdDt: item?.service?.createdDt,
            updatedDt: item?.service?.updatedDt,
            serviceName: item?.service?.serviceName,
            totalAmount: item?.totalAmount,
          })
        )}
        errorMessage={searchMessage}
        searchValue={
          searchValue || reportFromData.fromDate || reportFromData.toDate
        }
        handleSearch={setSearchValue}
        handleCheckAllBox={handleCheckAllBox}
        handleCheckboxChange={handleCheckboxChange}
        checkedItems={checkedItems}
        isCheckAll={isCheckAll}
        // handleShowGlobalViewModal={(item) =>
        //   navigate(`/payment_voucher/${referralCommission[0]?._id}/${item?.id}`)
        // }
        handleShowGlobalViewModal={(item) =>
          navigate(
            `/payment_voucher/${referralCommission[0]?._id}/${item?.id}`,
            {
              state: {
                clinicId: referralCommission[0]?.clinicId, // only clinic info
                referrerId: referralCommission[0]?.referrerId, // only referrer info
                selectedItem: item, // the clicked item
              },
            }
          )
        }
        handlePrint={handlePrint}
        showPaymentStatusTab={true}
        payemntHeaderColor="paymentTabcolor"
      />
      <Modal
        centered
        show={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Payment Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center">
            <div className="d-flex align-items-center gap-4">
              <label htmlFor="paymentStatus" className="col-form-label">
                Status:
              </label>
              {["UNPAID", "PAID"].map((status) => (
                <div className="form-check d-flex" key={status}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="paymentStatus"
                    id={status.toLowerCase()}
                    value={status}
                    checked={reportFromData.paymentStatus === status}
                    onChange={(e) => handleChangeFormData(e)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={status.toLowerCase()}
                  >
                    {status}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setShowPaymentModal(false)}
            className="p-2"
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleUpdateReferralCommissionPayment}
            className="p-2"
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ReferralCommissionPayment;
